import React, { useState, useEffect, useRef } from 'react';
import { Marker } from "react-simple-maps";
import Tooltip from '@material-ui/core/Tooltip';

import { makeBtStyles } from '../../Theme';


const useStyles = makeBtStyles( (theme,a,b) => ({
  circle: {
    transition: 'all 300ms',
    '&:hover': {
      transform: 'scale(1.5) !important'
    }
  },
  tooltip: props => ({
    backgroundColor: props.tooltipBgColor
  })
}));


export default function AnimatedRouteMarker({ location, radius, color, onAnimationEnd }) {
  const classes = useStyles({ tooltipBgColor: color });
  const [animate,setAnimate] = useState(false);
  const markerRef = useRef();

  useEffect( () => {
    if( markerRef.current.getClientRects() ) { // force reflow
      requestAnimationFrame( () => setAnimate(true) );
    }
  } );

  return (
    <Marker coordinates={[location.longitude,location.latitude]}>
      <Tooltip title={location.name} placement="top" classes={{ tooltip: classes.tooltip }}>
        <circle
          r={radius}
          fill={color}
          className={classes.circle}
          style={{
            transform: `scale(${animate ? 1 : 0.25})`,
            opacity: (animate ? 1 : 0)
          }}
          ref={markerRef}
          onTransitionEnd={onAnimationEnd}
        />
      </Tooltip>
    </Marker>
  );
};
